<template>
  <div>
    <swiper :options="swiperOption" class="swiper">
      <swiper-slide class="swiper-slide">
        <div class="banner h-100">
          <img src="../assets/img/banner/banner-index-1.jpg" />
          <div class="banner-text">
            <h1>安信软件</h1>
            <h2>为了信息化发展终将创造的所有美好</h2>
            <h3>Promotion of information technology.</h3>
          </div>
        </div>
      </swiper-slide>
      <swiper-slide class="swiper-slide">
        <div class="banner h-100">
          <img src="../assets/img/banner/banner-index-2.jpg" />
          <div class="banner-text">
            <h1>安信软件</h1>
            <h2>为了信息化发展终将创造的所有美好</h2>
            <h3>Promotion of information technology.</h3>
          </div>
        </div>
      </swiper-slide>
      <!-- 左右箭头 -->
      <div class="swiper-button-prev-rest" slot="button-prev"></div>
      <div class="swiper-button-next-rest" slot="button-next"></div>
    </swiper>
    <introduce></introduce>
    <product></product>
    <solution style="margin-top:60px"></solution>
    <news type="2" style="margin-top:120px"></news>
  </div>
</template>

<script>
import "swiper/css/swiper.css";
import news from "../compents/News";
import solution from "../compents/Solution";
import introduce from "../compents/Introduce";
import product from "../compents/Product";

import { swiper, swiperSlide } from "vue-awesome-swiper";
export default {
  components: {
    swiper,
    swiperSlide,
    news,
    introduce,
    product,
    solution
  },
  data() {
    return {
      swiperOption: {
        //设置点击箭头
        navigation: {
          nextEl: ".swiper-button-next-rest",
          prevEl: ".swiper-button-prev-rest"
        },
        //自动轮播
        autoplay: {
          delay: 5000,
          //当用户滑动图片后继续自动轮播
          disableOnInteraction: false
        },
        //开启循环模式
        loop: true
      }
    };
  }
};
</script>

<style lang="scss" scoped>
.swiper {
  height: 660px;
}
.banner {
  position: relative;
  .banner-text {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    text-align: center;
    h1 {
      color: #fff;
      font-size: 80px;
      letter-spacing: 8px;
      margin-bottom: 56px;
    }
    h2 {
      color: #fff;
      font-size: 36px;
      letter-spacing: 3.6px;
      font-weight: normal;
      margin-bottom: 26px;
    }
    h3 {
      color: #fff;
      font-size: 28px;
      letter-spacing: 8.4px;
      font-family: "Roboto Condensed", sans-serif;
      font-weight: 300;
    }
  }
}
.swiper-button-prev-rest {
  background: url("@/../../assets/img/index/btn-left.png");
  width: 49px;
  height: 96px;
  position: absolute;
  top: 50%;
  left: 60px;
  z-index: 100;
  transform: translateY(-50%);
  cursor: pointer;
}
.swiper-button-next-rest {
  background: url("@/../../assets/img/index/btn-right.png");
  width: 49px;
  height: 96px;
  position: absolute;
  top: 50%;
  right: 60px;
  z-index: 100;
  transform: translateY(-50%);
  cursor: pointer;
}
</style>
